import React from 'react'
import { useState } from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FilterButtonStatus from './FilterButtonStatus';

export default function FilterPopupReport(props) {
    const [checkedTypes, setCheckedTypes] = useState(props.filters.reportStatus);
    const [date_str, setDate_str] = useState(props.filters.reportDate_str);
    const [date_end, setDate_end] = useState(props.filters.reportDate_end);
    function onClearClick() {
        setCheckedTypes([]);
        setDate_str("");
        setDate_end("");
    }
    const handleClose = () => {
        var isSearch =false;

        if(date_str !== props.filters.reportDate_str || date_end !== props.filters.reportDate_end){
            props.onApplyFilter_noSearch("reportDate_str",date_str);
            props.onApplyFilter_noSearch("reportDate_end",date_end);
            isSearch = true;
        }

        if (checkedTypes !== undefined && props.filters.reportStatus !== undefined && !stringArrayEquals(props.filters.reportStatus, checkedTypes)) {
            props.onApplyFilter_noSearch("reportStatus",checkedTypes);
            isSearch = true;
        }

        //いずれかのフィルターが変更されていた場合は、検索する
        if(isSearch){
            props.onSearch();
        }
        
        props.onClose();
    };

    return (
        <ClickAwayListener onClickAway={handleClose}>
        <div role="dialog" className="hovercard noprint">
                <div className="hovercard-content hovercard-content-group">
                    <div >通報日<i className="bi bi-caret-down-fill"></i></div>
                    <div className="hovercard-Date" style={{margin:"3px 0"}}>
                        <input type="date"
                            value={date_str}
                            onChange={(e)=>setDate_str(e.target.value)}
                            max={date_end}
                        />
                        <span style={{margin:'0 5px'}}>～</span>
                        <input type="date"
                            value={date_end}
                            onChange={(e)=>setDate_end(e.target.value)}
                            min={date_str}
                        />
                    </div>
                </div>
                <div className="hovercard-content hovercard-content-group">
                    <div>
                        <div>ステータス<i className="bi bi-caret-down-fill"></i></div>
                        <div className="searchfilters">
                            
                            <FilterButtonStatus label="ステータス"
                                userAuthorities={props.userAuthorities}
                                keyword={props.keyword}
                                filters={props.filters}
                                width={props.width}
                                height={props.height}
                                anchorRef={props.anchorRef}
                                updateShowFiltersInfo={props.updateShowFiltersInfo}
                                viewtype={props.viewtype}
                                isMobileMode={props.isMobileMode}
                                onApplyFilter={props.onApplyFilter}
                                onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                                onClick={props.onSearchFilterClick}
                                
                                isDisabled={false}
                                isShow={true}

                                isReport={true}
                                masterKind={'reportStatus'}
                                filterKind={'reportStatus'}
                                targetTypes={checkedTypes}
                                setCheckedTypes={setCheckedTypes}
                                />
                            </div>
                    </div>
                </div>
                <div className="hovercard-buttons">
                    <button className="hovercard-button" onClick={onClearClick}>
                        <span className="hovercard-buttontext">クリア</span>
                    </button>
                    <button className="hovercard-button hovercard-lastbutton" onClick={handleClose}>
                        <span className="hovercard-buttontext hovercard-done">適用</span>
                    </button>
                </div>
            </div>
        </ClickAwayListener>
    );
}
function stringArrayEquals(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}